import React from 'react'

const AddPartnerIcon = (props) => {
    return (
        <img src={props.selected ? "/assets/icons/add-partner.svg" : "/assets/icons/add-partner.svg"}
             alt="add partner"
             style={props.style}
        />
    )
}

export default AddPartnerIcon